import { createStorageService } from "@/lib/storage/gcs/googleCloudStorage";
import { IStorageService } from "@/lib/storage/storage";

export class ConversationFileService {
  private storage: IStorageService = createStorageService();
  private destination: string = "conversations/";
  async uploadFile(file: File, conversationId: string, fileName: string) {
    const filePath = `${this.destination}${conversationId}/${fileName}`;
    return await this.storage.uploadPrivateFile(file, filePath);
  }

  async getFileData(filePath: string) {
    return await this.storage.getPrivateFileSignedUrl(filePath);
  }

  async downloadFile(filePath: string) {
    return await this.storage.downloadPrivateFile(filePath);
  }
}

export const conversationFileService = new ConversationFileService();
